<template>
  <div style="width: 100%" class="mt-15">
    <h2 class="m_title">{{ $t('component.request_information.request_information') }}</h2>
    <v-row>
      <v-col cols="12">
        <div class="application__info__wrap">
          <dl>
            <dt>{{ $t('component.request_information.request_no') }}</dt>
            <dd>{{ receipt_no }}</dd>
          </dl>
          <dl>
            <dt>{{ $t('component.request_information.requests_service') }}</dt>
            <dd>{{ $vuetify.rtl ? service_name_ar : service_name_en }}</dd>
          </dl>
          <dl>
            <dt>{{ $t('component.request_information.name') }}</dt>
            <dd>{{ $vuetify.rtl ? name_ar : name_en }}</dd>
          </dl>
          <dl>
            <dt>{{ $t('component.request_information.company') }}</dt>
            <dd>{{ $vuetify.rtl ? company_name_ar : company_name_en }}</dd>
          </dl>
          <dl>
            <dt>{{ $t('component.request_information.address') }}</dt>
            <dd>{{ $vuetify.rtl ? address_ar : address_en }}</dd>
          </dl>
          <dl>
            <dt>{{ $t('component.request_information.tel') }}</dt>
            <dd>{{ telephone }}</dd>
          </dl>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'

export default {
  name: 'RequestInformation',
  props : {
    receipt_no: String
  },
  components :{
  },
  data () {
    return {
      request_service_code : '',
      service_name_ar : '',
      service_name_en : '',
      name_ar : '',
      name_en : '',
      company_name_ar : '',
      company_name_en : '',
      address_ar : '',
      address_en : '',
      telephone : ''
    }
  },
  mounted(){
    this.getRequestInformation()
  },
  methods: {
    getRequestInformation(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/request',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.request_service_code = res.data.request_service_code
            this.service_name_ar = res.data.service_name_ar
            this.service_name_en = res.data.service_name_en
            this.name_ar = res.data.name_ar
            this.name_en = res.data.name_en
            this.company_name_ar = res.data.company_name_ar
            this.company_name_en = res.data.company_name_en
            this.address_ar = res.data.address_ar
            this.address_en = res.data.address_en
            this.telephone = res.data.telephone

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getRequestInformation()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }
  },
}
</script>